<div class="badges-wrapper">
  <ng-content select="[paidPackage]"></ng-content>
  <ng-container *ngIf="device | dashboardAnomalyPill as anomalyPills">
    <app-pill
      *ngFor="let pill of anomalyPills"
      [type]="pill.pillType"
      [matTooltip]="pill.tooltipText"
    >
      {{ pill.label }}
    </app-pill>
  </ng-container>

  <app-pill *ngIf="device | dashboardOperatingMode as operatingModes" [type]="pillType.neutral">
    {{ operatingModes }}
  </app-pill>
</div>
